<template>
  <div class="overlay">
    <basic-overlay-style :bounding-box="boundingBox" :color="color" />
  </div>
</template>

<script>
import BasicOverlayStyles from './BasicOverlayStyles';

export default {
  components: {
    'basic-overlay-style': BasicOverlayStyles,
  },
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    color: {
      type: [Array, String],
      required: true,
    },
  },
};
</script>
